import React from 'react'

import View from '../../../../../components/pdf/View'

const Intro = () => {
  return (
    <View
      pageBreakAfter
      style={{
        maxWidth: '25cm',
        minHeight: '27.5cm',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundImage: 'url("/pdfs/vivo/vivo_fundo.png")',
        backgroundSize: '100% 100%'
      }}
    ></View>
  )
}

export default Intro
